export const redirectPath = (path: string, history: any) => {
  return history.location.pathname === path ? null : history.push(path);
};
